import React from 'react';
import { useStyles } from './SnackbarDownload.styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircleOutline';
import { Snackbar, SnackbarProps } from '@material-ui/core';

interface SnackbarDownloadProps extends SnackbarProps {
  text: string;
}
export const SnackbarDownload: React.FC<SnackbarDownloadProps> = (props) => {
  const classes = useStyles();

  return (
    <Snackbar {...props} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <span className={classes.badge}>
        <CheckCircleIcon className={classes.success} />
        {props.text}
      </span>
    </Snackbar>
  );
};
